import { reactive } from 'vue';

const state = reactive({
  selectedByConversation: {},
});

const keyFor = conversationId => String(conversationId || '');

export function selectedRelatedContactIds(conversationId) {
  return state.selectedByConversation[keyFor(conversationId)] || [];
}

export function setSelectedRelatedContactIds(conversationId, ids = []) {
  state.selectedByConversation[keyFor(conversationId)] = ids
    .map(id => Number(id))
    .filter(Boolean);
}

export default state;
